import React, { useState, useEffect } from "react";
import UiButton from "../../Common/UiButton/UiButton";
import "../../PartnerManagement/AddPartner/Style.css";
import { Col, Row } from "react-bootstrap";
import TextInput from "../../Common/UITextInput/TextInput";
import { Form, Drawer, message, notification, Checkbox } from "antd";
import UiDropDown from "../../Common/UiDropDown/UiDropDown";
import useForm from "../../../common/hooks/useForm";
import "./style.css";
import {
  getAddEmployeeDetail,
  getProductInfo,
  saveAddEmployeeDetails,
} from "../../../redux/AddEmployee/action";
import { connect } from "react-redux";
import { getMasterBranchDataDetails } from "../../../redux/BranchPrefernces/action";
import useSession from "../../CustomLogout/useSession";
const AddEmployee = ({ userRefresh, setUserRefresh, ...props }) => {
  const [form] = Form.useForm();
  const FormItem = Form.Item;
  const [branchDtoList, setBranchDtoList] = useState([]);
  const [productList, setProductList] = useState([]);
  const { state, onChangeTextHandler, setState } = useForm();

  const [open, setOpen] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);
  const showDrawer = () => {
    setOpen(true);
    setBtnDisable(false);
  };

  const onClose = () => {
    setOpen(false);
    setBtnDisable(false);
    form.resetFields();
  };
  const handleSessionExpired = useSession();

  useEffect(() => {
    props.getAddEmployeeDetail(props.access_token);
    props
      .getMasterBranchDataDetails({
        access_token: props.access_token,
      })
      .then((res) => {
        setBranchDtoList(res?.data?.dtoList);
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
    props
      ?.getProductInfo({
        accessToken: props.access_token,
      })
      .then((res) => {
        setProductList(
          res?.data?.dtoList?.map((el) => {
            return {
              label: el?.productName,
              value: el?.productId,
            };
          })
        );

        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  }, []);

  const roleTypeList =
    props.addEmployeeData?.getAddEmployee?.length > 0
      ? props.addEmployeeData?.getAddEmployee.map((el) => {
          return {
            label: el.role,
            value: el.id,
          };
        })
      : [];

  const handleChangeSelect = (val) => {
    setState({
      ...state,
      roleType: {
        id: val.id,
        name: val.label,
      },
    });
  };

  const handleChange = (data) => {
    const addEmployeedataSave = {
      employeeCode: data?.employeeCode,
      roleType: {
        id: state.roleType?.id ?? state.roleType?.id,
        role: state.roleType?.label ?? state.roleType?.name,
      },
      userFirstName: data.employeeFirstName?.trim(),
      userLastName: data.employeeLastName?.trim(),
      emailAddress: data.email?.trim(),
      ldapId: data.ldapId,
      avanseBranchIds: [data?.BranchName?.value],
      // productTypeIds: data?.productType
    };

    console.log("line 124", data);
    setBtnDisable(true);
    props
      .saveAddEmployeeDetails({
        values: addEmployeedataSave,
        access_token: props.access_token,
      })
      .then((res) => {
        if (res && res.status === 200) {
          message.success("Add Employee Successfully");
          setBtnDisable(false);
          setOpen(false);
          setUserRefresh(true);
          form.resetFields();
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;
          setBtnDisable(false);
          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              message: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };

  let branchOptions =
    branchDtoList?.length > 0
      ? branchDtoList.map((el) => {
          return {
            label: el?.branchName,
            value: el?.branchId,
          };
        })
      : "";
  const options = [
    { label: "Apple", value: "Apple" },
    { label: "Pear", value: "Pear" },
    { label: "Orange", value: "Orange" },
  ];

  return (
    <div className="addpartner-section" id="add-employee-sec">
      <UiButton title="Add Employee" onClick={showDrawer} />
      <Drawer
        title="Basic Drawer"
        placement="right"
        onClose={onClose}
        open={open}
        className="add-partner-dow"
      >
        <Form
          autoComplete="off"
          form={form}
          name="addEmployee"
          onFinish={handleChange}
        >
          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              className="add-content-partner"
            >
              <Col md={6} className="addpartnerheading">
                <h2 className="main-heading">Add Employee</h2>
                <div className="headre-line"></div>
              </Col>
              <Col md={6} className="btn-section mb-sec-ad">
                <h2 onClick={onClose} className="cancel-btn-add">
                  cancel
                </h2>
                {/* <UiButton type="submit" title="Create Employee" /> */}
              </Col>
            </Col>
          </Row>
          <h3 className="sub-text">Employee Info</h3>
          <Row>
            <Col lg={12} xs={12} md={12} sm={12} className="add-fields-partner">
              <Col md={4}>
                <FormItem
                  name="employeeCode"
                  label="employee Code"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Employee Code",
                    },
                  ]}
                >
                  <TextInput
                    name="employeeCode"
                    onChange={onChangeTextHandler}
                    type="number"
                    onInput={(e) => {
                      if (e.target.value.trim() == "") {
                        e.target.value = e.target.value.trim();
                      }

                      if (e.target.value.trim() !== "") {
                        e.target.value = new RegExp("^[0-9-+]*$").test(
                          e.target.value
                        )
                          ? e.target.value?.trimStart()
                          : e.target.value
                              ?.trimStart()
                              ?.substring(0, e.target.value.length - 1);
                      }
                    }}
                  />
                </FormItem>
              </Col>
              <Col md={4} className="mob-sec-eF">
                <FormItem
                  name="employeeFirstName"
                  label="Employee First Name"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Employee First Name",
                    },
                    {
                      pattern: new RegExp("^[a-zA-Z]+$"),
                      message: "please enter a valid first name",
                    },
                  ]}
                >
                  <TextInput
                    type="text"
                    onInput={(e) => {
                      if (e.target.value.trim() == "") {
                        e.target.value = e.target.value.trim();
                      }

                      if (e.target.value.trim() !== "") {
                        e.target.value = new RegExp("^[a-zA-Z]+$").test(
                          e.target.value
                        )
                          ? e.target.value?.trimStart()
                          : e.target.value
                              ?.trimStart()
                              ?.substring(0, e.target.value.length - 1);
                      }
                    }}
                    name="employeeFirstName"
                    value={state.employeeFirstName}
                    onChange={onChangeTextHandler}
                  />
                </FormItem>
              </Col>
              <Col md={4} className="mob-sec-eF">
                <FormItem
                  name="employeeLastName"
                  label="Employee Last Name"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Employee Last Name",
                    },
                    {
                      pattern: new RegExp("^[a-zA-Z]+$"),
                      message: "please enter a valid last name",
                    },
                  ]}
                >
                  <TextInput
                    onInput={(e) => {
                      if (e.target.value.trim() == "") {
                        e.target.value = e.target.value.trim();
                      }

                      if (e.target.value.trim() !== "") {
                        e.target.value = new RegExp("^[a-zA-Z]+$").test(
                          e.target.value
                        )
                          ? e.target.value?.trimStart()
                          : e.target.value
                              ?.trimStart()
                              ?.substring(0, e.target.value.length - 1);
                      }
                    }}
                    value={state.employeeLastName}
                    onChange={onChangeTextHandler}
                    type="text"
                  />
                </FormItem>
              </Col>
            </Col>
          </Row>

          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              style={{ marginTop: "10px" }}
              className="add-fields-partner"
            >
              <Col md={4}>
                <FormItem
                  name="email"
                  label="Email Address"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Email Required!",
                    },
                  ]}
                >
                  <TextInput
                    maxLength={255}
                    type="email"
                    name="email"
                    onInput={(e) => {
                      if (e.target.value.trim() == "") {
                        e.target.value = e.target.value.trim();
                      }

                      if (e.target.value.trim() !== "") {
                        e.target.value = e.target.value.trimStart();
                      }
                    }}
                    validation={[
                      {
                        type: "email",
                        message: "Invalid Email!",
                      },
                    ]}
                    onChange={onChangeTextHandler}
                  />
                </FormItem>
              </Col>
              <Col md={4} className="mob-sec-eF">
                <FormItem
                  name="ldapId"
                  label="ldap Id"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter ldap Id",
                    },
                  ]}
                >
                  <TextInput
                    onInput={(e) => {
                      if (e.target.value.trim() == "") {
                        e.target.value = e.target.value.trim();
                      }

                      if (e.target.value.trim() !== "") {
                        e.target.value = e.target.value.trimStart();
                      }
                      if (e.target.value.trim() !== "") {
                        e.target.value = e.target.value.trimEnd();
                      }
                    }}
                    value={state.ldapId}
                    onChange={onChangeTextHandler}
                    type="text"
                  />
                </FormItem>
              </Col>
              <Col md={4} className="select-roleTye-mob ">
                <FormItem
                  name="BranchName"
                  label="Branch Name"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Select Role",
                    },
                  ]}
                >
                  <UiDropDown
                    className="new-role-sec"
                    data={branchOptions}
                    placeholder="Select"
                  />
                </FormItem>
              </Col>
            </Col>
          </Row>

          <h3 className="sub-text">Role Info</h3>
          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              className="add-fields-partner mob-sec-role"
            >
              <Col md={12} className="select-roleTye-mob ">
                <FormItem
                  name="roleType"
                  label="Role In Partner Portal"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Select Role",
                    },
                  ]}
                >
                  <UiDropDown
                    className="new-role-sec"
                    onChange={handleChangeSelect}
                    data={roleTypeList}
                    placeholder="Select"
                  />
                </FormItem>
              </Col>
            </Col>
          </Row>

          {/* <h3 className="sub-text">Product Info</h3>
          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              className="add-fields-partner mob-sec-role"
            >
              <Col md={12} className="add-partner-checkbox mob-chk-d">
                <FormItem
                  name="productType"
                  label="product Partner Portal"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Select Role",
                    },
                  ]}
                >
                  <Checkbox.Group
                    options={productList}



                  />
                </FormItem>
              </Col>
            </Col>
          </Row> */}
          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              style={{ marginTop: "10px" }}
              className="add-fields-partner last-btn-sec-changes"
            >
              <Col md={12}>
                <UiButton
                  disabled={btnDisable}
                  type="submit"
                  title="Create Employee"
                  className="primary-btn"
                />
              </Col>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
    addEmployeeData: state.addEmployeeData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAddEmployeeDetail: (accessToken) =>
      dispatch(getAddEmployeeDetail(accessToken)),
    saveAddEmployeeDetails: (data) => dispatch(saveAddEmployeeDetails(data)),
    getMasterBranchDataDetails: (data) =>
      dispatch(getMasterBranchDataDetails(data)),
    getProductInfo: (data) => dispatch(getProductInfo(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddEmployee);
